import { section, align } from '@settings/common';

export function Schema() {
  return {
    category: 'LoyaltyLion',
    label: 'LoyaltyLion Tier Progress',
    key: 'loyaltyllion-tier-progress',
    fields: [
      {
        label: 'Heading',
        name: 'heading',
        component: 'text',
      },
      {
        label: 'SubHeading',
        name: 'subHeading',
        component: 'text',
      },
      {
        label: 'Heading alignment (mobile)',
        name: 'alignment',
        component: 'radio-group',
        direction: 'horizontal',
        variant: 'radio',
        options: align.options,
      },
      {
        label: 'Heading alignment (desktop)',
        name: 'alignmentDt',
        component: 'radio-group',
        direction: 'horizontal',
        variant: 'radio',
        options: align.options,
      },
      {
        ...section,
        defaultValue: {
          desktop: {
            container: 'container',
            mt: 'none',
            py: 'none',
          },
          mobile: {
            container: 'content',
            mt: 'none',
            py: 'none',
          },
        },
      },
    ],
    defaultValue: {
      subHeading: 'Your Member Ship Status',
      alignment: align.value.left,
      alignmentDt: align.value.left,
    },
  };
}
